<template>
  <Layout class="home">
    <Title
      title="Dispositivos"
      margin="large"
    />
    <Panel
      v-if="!isDevices && !loading"
    >
      Você ainda não tem nenhum dispositivo
    </Panel>

    <fragment v-if="isDevices">
      <b-row
        cols="1"
        cols-md="3"
        cols-sm="2"
      >
        <b-col
          v-for="device  in devices"
          :key="device.id"
        >
          <Button
            type="clean"
            @click="() => editDevice(device)"
          >
            <card
              :title="device.name"
              :actions="actions(device)"
            >
              <div>
                <b>Ambiente:</b>
                {{env(device.configuration.ambiente)}}
              </div>
              <div>
                <b>Série:</b>
                {{device.configuration.serie}}
              </div>
              <div>
                <b>Próxima Nota:</b>
                {{device.configuration.proximaNota}}
              </div>
            </card>
          </Button>
        </b-col>
      </b-row>
    </fragment>

    <ModalConfiguration
      v-model="modalConfigurations"
      :data="selected"
      :avaliableSat="isClientFromSP"
      :environments="ambientes"
      :save="handleSave"
    />
  </Layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import IconTrash from 'vue-material-design-icons/TrashCan';

import { AMBIENTE_LABEL } from '../enums/Ambientes';
import { MODELO_LABEL } from '../enums/Documento';

import Panel from '../../../components/Panel';
import Layout from '../../../components/Layout';
import Title from '../../../components/Title';
import Card, { CardActions } from '../../../components/Card';
import ModalConfiguration, { ModalConfigurationData } from '../components/ModalConfiguration';
import { Button } from '../../../components/Form';

import { ClientMixin } from '../../Application';
import AmbienteMixin from '../mixins/AmbienteMixin';

export default {
  name: 'FiscalConfiguration',
  mixins: [
    ClientMixin,
    AmbienteMixin,
  ],
  components: {
    Title,
    Panel,
    Card,
    ModalConfiguration,
    Button,
    Layout,
  },
  data() {
    return {
      modalConfigurations: false,
      selected: new ModalConfigurationData({}),
      devices: [],
    };
  },
  props: {
    confirm: {
      type: Function,
    },
  },
  mounted() {
    const getDataInit = async () => {
      this.setLoading(true);
      await this.getClient();
      await this.getAmbientes();
      const { data } = await this.$http.get('compupos.get-device');
      this.devices = data;
      this.setLoading(false);
    };
    getDataInit();
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    actions(device) {
      const actions = new CardActions();
      actions.addAction(
        IconTrash,
        () => {
          this.confirm({
            title: 'Remover dispositivo',
            message: 'Deseja realmente remover esse dispositivo?',
            onOk: async () => {
              try {
                this.setLoading(true);
                await this.$http.post('compupos.remove-device', {
                  id: device.id,
                });
                const { data } = await this.$http.get('compupos.get-device');
                this.devices = data;
                this.setLoading(false);
                this.$alert.success('Dispositivo removido com sucesso.');
              } catch (e) {
                this.$alert.error(e?.response?.data?.error_message);
                this.setLoading(false);
              }
            },
          });
        },
      );
      return actions;
    },
    editDevice(device) {
      if (!device) {
        this.selected = new ModalConfigurationData({});
        this.modalConfigurations = true;
        return;
      }

      this.selected = new ModalConfigurationData({
        id: device.configuration.id,
        serie: device.configuration.serie,
        proximaNota: device.configuration.proximaNota,
        idTokenCSC: device.configuration.idTokenCSC,
        tokenCSC: device.configuration.tokenCSC,
        documento: device.configuration.modelo,
        ambiente: device.configuration.ambiente,
        ativo: device.configuration.ativo,
        printType: device.configuration.printType,
        codigoAtivacao: device.configuration.codigoAtivacao,
        versao: device.configuration.versao,
        assinatura: device.configuration.assinatura,
      });
      this.modalConfigurations = false;
      this.modalConfigurations = true;
    },
    env(currentEnv) {
      return AMBIENTE_LABEL[currentEnv];
    },
    getName(modelo) {
      return MODELO_LABEL[modelo];
    },
    async handleSave(form) {
      try {
        this.setLoading(true);
        await this.$http.post(
          form.id ? 'fiscal.put-configuracao' : 'fiscal.post-configuracao',
          form,
        );
        const { data } = await this.$http.get('compupos.get-device');
        this.devices = data;
        this.modalConfigurations = false;
        this.setLoading(false);
        this.$alert.success('Dispositivo salvo com sucesso.');
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
        this.selected = form;
        this.setLoading(false);
      }
    },
  },
  computed: {
    ...mapState('application', ['loading']),
    isDevices() {
      return this.devices.length > 0;
    },
  },
};
</script>
